<template>
  <div :class="computedClass">
    <JadeIcon
      v-if="error"
      use="circle-alert"
      size="small"
      color="negative"
    />
    <JadeText
      color="current-color"
      variant="text-small"
      weight="regular"
    >
      <slot />
    </JadeText>
  </div>
</template>

<script>
import JadeIcon from '../JadeIcon'
import JadeText from '../JadeText'

export default {
  name: 'JadeSupportText',
  components: {
    JadeText,
    JadeIcon
  },
  props: {
    error: Boolean,
    disabled: Boolean
  },
  computed: {
    computedClass () {
      return {
        'jade-support-text': true,
        'is-errored': this.error,
        'is-disabled': this.disabled
      }
    }
  }
}
</script>

<style>
@import '@stone-payments/jade/css/support-text.css';
</style>
